import React, { useEffect } from 'react';
import { ConnectedRouter} from 'connected-react-router';
import { Route, Redirect, Switch } from 'react-router-dom';

import './App.css';

/* layout definitions */
import AppLayout from './screens/layouts/AppLayout';
import MainLayout from './screens/layouts/MainLayout';

import NoMatch from './screens/NoMatch';
import Login from './screens/Login';
import Forgot from './screens/Forgot';
import Map from './screens/Map';
import Dashboard from './screens/Dashboard';
import Projects from './screens/Projects';
import { history } from './state/store';

//temp
import Dashboard_smart from "./screens/dashboard_screens/dashboard_smart";
import Dashboard_kataszter from "./screens/dashboard_screens/dashboard_kataszter";
import Dashboard_thirdparty from "./screens/dashboard_screens/dashboard_thirdparty";
import Dashboard_details from "./screens/dashboard_screens/dashboard_details";
import DashboardCityMarketing from "./screens/dashboard_screens/dashboard_citymarketing";
import DashboardThirdpartyDetails from "./screens/dashboard_screens/dashboard_thirdparty_details";
import dashboard_pharos from './screens/dashboard_screens/dashboard_pharos';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { faParticles, faSensors,faLights,faTotem,faSmartready, faSmart } from './assets/icons/CustomIcons';

import withAuth from "./helpers/auth";

library.add(fal);
library.add(far);
library.add(fas);
library.add(faParticles);
library.add(faSensors);
library.add(faLights);
library.add(faTotem);
library.add(faSmartready);
library.add(faSmart);

function App() {

    useEffect(() => {

    }, [])

    useEffect(() => {
        const loadBackgroundImage = async () => {
            try {
                const dynamicBgdImage = require(`./assets/images/${process.env.REACT_APP_BGD_IMG}`);
  
                if (dynamicBgdImage) {
                    if(document !== undefined) {
                        document.getElementById('root').style = `background-image: url(${dynamicBgdImage})`;
                        document.body.style.backgroundImage = `url(${dynamicBgdImage})`;
                    }                
                } else {
                    throw new Error(`Logo not found`);
                }
            } catch (error) {
                console.error('Error loading dynamic logo:', error);
            }
        };

        loadBackgroundImage();
    }, []);

    return (
            <ConnectedRouter history={history}>
                    <Route component={AppLayout}>
                        <Switch>
                            <Route exact path="/" component={() => <Redirect to="/login" />}/>
                            <Route component={MainLayout}>
                                <Switch>
                                    <Route path="/login" component={withAuth(Login)} breadcrumbName={'common:breadcrumbs.Settings'} />
                                    <Route path="/dashboard" component={withAuth(Dashboard)}/>
                                    <Route path="/forgot/:token" component={Forgot} breadcrumbName={'common:breadcrumbs.Settings'} />

                                    <Route path="/smart/:type/:value" component={withAuth(Dashboard_details)}/>
                                    <Route path="/smart" component={withAuth(Dashboard_smart)} />

                                    <Route path="/kataszter" component={withAuth(Dashboard_kataszter)} />
                                    <Route path="/thirdparty" component={withAuth(Dashboard_thirdparty)} />
                                    <Route path="/interface" component={withAuth(DashboardThirdpartyDetails)} />
                                    <Route path="/citymarketing" component={withAuth(DashboardCityMarketing)}/>
                                    <Route path="/pharos" component={withAuth(dashboard_pharos)} />

                                    <Route path="/map" component={withAuth(Map)} breadcrumbName={'common:breadcrumbs.Dashboard'} />
                                    <Route path="/project" component={withAuth(Projects)} breadcrumbName={'common:breadcrumbs.Projects'} />
                                    <Route path="*" component={withAuth(NoMatch)} breadcrumbName={'common:breadcrumbs.page-not-found'} title="404" />
                                </Switch>
                            </Route>
                        </Switch>
                    </Route>
            </ConnectedRouter>
    );
}

export default App;
